export default __webpack_public_path__ + "assets/c459699c4b15221e29e9b14d428b3974.webp";